export const COUNTDOWN = 'COUNTDOWN';
export const COUNTDOWN_DURATION = 30;
export const ONE_SECONDS_INTERVAL = 1000;
